import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader';
import Pagination from 'screens/components/basic/Pagination';
import { Link } from 'react-router-dom';
import { roundToDecimalPlace } from 'utils/helpers';


class CategoryProductView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            activePage: 1
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.changePage = this.changePage.bind(this);
    }

    handleToggle() {
        this.setState({ open: !this.state.open, activePage: 1 });
    }

    changePage(e) {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        })
    }

    render() {
        //to do: only pull single category data when clicked
        let category = this.props.item;
        let productData = this.props.productData ? this.props.productData.filter(item => item.categoryId == category.categoryId) : [];
        return (
            <div>
                <Link onClick={this.handleToggle}>
                    <span className="text-info">View</span>
                </Link>

                <DialogInput
                    title={<div className='modal-title p-0'>
                        <DialogHeader text={category.categoryName} />
                    </div>
                    }
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label="Cancel"
                            onTouchTap={() => this.handleToggle()} />
                    ]}
                    modal={true}
                    handleClose={() => this.handleToggle()}
                    open={this.state.open}
                    autoScrollBodyContent
                >
                    <h4>Product Summary for {category.categoryName}</h4>
                    <table className="table table-striped table-hover table-responsive">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>SKU</th>
                                <th>Quantity</th>
                                <th className="nowrap">Net Sales</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                productData.sort((a, b) => b.netSales - a.netSales).slice((this.state.activePage - 1) * 10, (this.state.activePage - 1) * 10 + 10).map((product, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{product.productName}</td>
                                            <td>{product.sku}</td>
                                            <td>{product.itemsSold}</td>
                                            <td>{getDollarFormat(product.netSales)}</td>
                                        </tr>
                                    )
                                }
                                )
                            }
                        </tbody>
                    </table>
                    <Pagination
                        itemsPerPage={10}
                        activePage={this.state.activePage}
                        onPageChange={this.changePage}
                        length={productData.length >= 10 ? productData.length : 0}
                    />
                </DialogInput>
            </div>

        );
    }
}

class Body extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };

    }

    getDataForPlotting = (dateCategoryData, categoryList, dateList) => {
        let finalArray = [];

        dateList.map(timeframe => {
            let tempDict = {};
            tempDict["date"] = moment(timeframe).format("YYYY-MM-DD");
            categoryList.map(categoryName => {
                let foundCategory = dateCategoryData.filter(x => x.categoryName == categoryName && x.date == timeframe).sort()
                tempDict[categoryName] = foundCategory.length > 0 ? foundCategory[0].netSales : 0
            })
            finalArray.push(tempDict);
        })
        return finalArray
    }

    colors = ['#7a60e5', '#009CE0', '#16A5A5', '#68BC00', '#B0BC00', '#FCC400', '#E27300', '#D33115', '#FA28FF', '#AEA1FF', '#73D8FF', '#68CCCA', '#A4DD00', '#DBDF00', '#FCDC00', '#FE9200', '#F44E3B', '#FDA1FF', '#653294', '#0062B1', '#0C797D', '#194D33', '#808900', '#FB9E00', '#C45100', '#9F0500', '#AB149E'];

    generateBars = (categoryList) => {
        let bars = [];
        categoryList.forEach((category, index) => {
            bars.unshift(<Bar dataKey={category} stackId="a" id={category} fill={this.colors[index]} />)
        })
        return bars
    }

    customTooltip = ({ payload, label, active }, categoryList) => {

        if (active && payload.length > 0) {

            const data = payload[0].payload;

            let newCategoryList = []

            categoryList.forEach((category, index) => {
                newCategoryList.push(
                    <div className="custom-tooltip-category-line">
                        <span style={{ color: this.colors[index] }} className="custom-tooltip-circle">•</span>
                        <span> {category}:  ${data[category]} </span>
                    </div>)
            });

            return (

                <div className="custom-tooltip">
                    <span className="fw_bold">{data.date}</span>
                    {newCategoryList}

                </div>
            );
        }

        return null;
    }

    render() {
        let categorySales = this.props.categorySales;
        let allCategoryData = categorySales ? categorySales.categoryData : [];
        let endDate = this.props.endDate;
        let beginDate = this.props.beginDate;

        let dateCategoryData = allCategoryData ? allCategoryData.filter(item => item.recordType == "DateCategory") : [];
        let categoryData = allCategoryData ? allCategoryData.filter(item => item.recordType == "Category") : [];
        let isCannabisData = allCategoryData ? allCategoryData.filter(item => item.recordType == "IsCannabis") : [];
        let productData = categorySales ? categorySales.productData : [];


        let categoryList = Array.from(new Set(dateCategoryData.map(item => item.categoryName)));
        let dateList = Array.from(new Set(dateCategoryData.map(item => item.date)))

        let dataForPlotting = this.getDataForPlotting(dateCategoryData, categoryList, dateList);
        let totalNetSales = isCannabisData.reduce((acc, data) => acc + data.netSales, 0);


        return (
            <div className="row m-0">
                {
                    !categorySales || !categorySales.categoryData || categorySales.categoryData.length <= 0 ||
                        !categorySales.productData || categorySales.productData.length <= 0
                        ?
                        //If there's NO DATA to display
                        <NoDataMsg />
                        :
                        //If there's DATA

                        <div>

                            <div className="row m-0">
                                <div className="text-center list_header">
                                    {beginDate ?
                                        <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                            {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                        : ""}
                                </div>
                            </div>
                            <div className="col-lg-12 mt-2">
                                <div className="col-lg-12">
                                    <h4 className="text-center">Net Sales Over Time</h4>
                                    <ResponsiveContainer width="100%" height={400}>
                                        <BarChart
                                            data={dataForPlotting}
                                        >
                                            <XAxis dataKey="date" tick={{ fontSize: 10 }} />
                                            <YAxis tick={{ fontSize: 10 }} />
                                            {this.generateBars(categoryList)}
                                            <Tooltip content={(e) => this.customTooltip(e, categoryList)} cursor={{ fill: "#D4D1FF20" }} />
                                        </BarChart>

                                    </ResponsiveContainer>
                                    {/* {exceedPlotRange && <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: This chart may be compressed to display the most recent activity</p>} */}
                                    <br />
                                </div>
                            </div>
                            <div className="col-lg-12 mt-1">
                                <h4>Parent Category Summary</h4>
                                <table className="table table-striped table-hover table-responsive">
                                    <thead>
                                        <tr>
                                            <th className='tableHeaderColorGray'>Category</th>
                                            <th className='tableHeaderColorGray'>Quantity</th>
                                            <th className='tableHeaderColorGray nowrap'>Gross Sales</th>
                                            <th className='tableHeaderColorGray'>Refunds</th>
                                            <th className='tableHeaderColorGray'>Discounts</th>
                                            <th className='tableHeaderColorGray nowrap'>Net Sales</th>
                                            <th className='tableHeaderColorGray nowrap'>Total Net Sales %</th>
                                            <th className='tableHeaderColorGray'>Cost</th>
                                            <th className='tableHeaderColorGray'>Profit</th>
                                            <th className='tableHeaderColorGray'>Margin</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            isCannabisData ? isCannabisData.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className='purpleText'>{item.categoryName}</td>
                                                        <td className='purpleText'>{item.itemsSold}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.grossSales)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.refundAmount)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.discounts)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.netSales)}</td>
                                                        <td className='purpleText'>{`${roundToDecimalPlace(item.netSales / totalNetSales * 100, 2)}%`}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.exactCosts)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.grossProfitExact)}</td>
                                                        <td className='purpleText'>{`${roundToDecimalPlace(item.grossProfitPercent, 2)}%`}</td>
                                                    </tr>
                                                )
                                            }) : <tr></tr>
                                        }
                                    </tbody>
                                </table>

                            </div>
                            <div className="col-lg-12 mt-1">
                                <h4>Sub-category Summary</h4>
                                <table className="table table-striped table-hover table-responsive">
                                    <thead>
                                        <tr>
                                            <th className='tableHeaderColorGray'>Category</th>
                                            <th className='tableHeaderColorGray'>Quantity</th>
                                            <th className='tableHeaderColorGray nowrap'>Gross Sales</th>
                                            <th className='tableHeaderColorGray'>Refunds</th>
                                            <th className='tableHeaderColorGray'>Discounts</th>
                                            <th className='tableHeaderColorGray nowrap'>Net Sales</th>
                                            <th className='tableHeaderColorGray nowrap'>Total Net Sales %</th>
                                            <th className='tableHeaderColorGray'>Cost</th>
                                            <th className='tableHeaderColorGray'>Profit</th>
                                            <th className='tableHeaderColorGray'>Margin</th>
                                            <th className='tableHeaderColorGray'>Products</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            categoryData ? categoryData.sort((a, b) => b.netSales - a.netSales).map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className='purpleText'>{item.categoryName}</td>
                                                        <td className='purpleText'>{item.itemsSold}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.grossSales)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.refundAmount)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.discounts)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.netSales)}</td>
                                                        <td className='purpleText'>{`${roundToDecimalPlace(item.netSales / totalNetSales * 100, 2)}%`}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.exactCosts)}</td>
                                                        <td className='purpleText'>{getDollarFormat(item.grossProfitExact)}</td>
                                                        <td className='purpleText'>{`${roundToDecimalPlace(item.grossProfitPercent, 2)}%`}</td>
                                                        <td className='purpleText'>
                                                            <CategoryProductView
                                                                item={item}
                                                                productData={productData}
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            }) : <tr></tr>
                                        }
                                    </tbody>
                                </table>

                            </div>
                        </div>
                }
            </div>
        )

    }

}

export default Body;